export const solutions = {
  hero: {
    title: 'Solutions',
    subtitle: 'Financial architecture applied to structured wealth decisions.'
  },
  items: [
    {
      id: 'aquisicao-imobiliaria',
      title: 'Real Estate Acquisition',
      forWho: {
        label: 'Who is it for',
        text: 'Individuals and legal entities seeking to acquire residential or commercial properties with planned credit structure and technical governance.'
      },
      whenMakesSense: {
        label: 'When it makes sense',
        text: 'When there is clarity about the desired asset, defined monthly payment capacity, and medium to long-term horizon for contemplation or bid.'
      },
      variables: {
        label: 'Variables and restrictions',
        text: 'Property value, group term, administration fee, reserve fund, contemplation dynamics (draw/bid), administrator regulations.'
      },
      howFgt: {
        label: 'How FGT structures',
        text: 'Complete wealth diagnosis, active group analysis, scenario modeling (base and stress), bid structuring when applicable, monitoring until credit utilization.'
      }
    },
    {
      id: 'construcao-reforma',
      title: 'Construction and Renovation',
      forWho: {
        label: 'Who is it for',
        text: 'Land or property owners planning to build or renovate with structured credit via real estate consortium.'
      },
      whenMakesSense: {
        label: 'When it makes sense',
        text: 'When there is a defined project, validated technical budget, and need for credit without immediate commitment of wealth liquidity.'
      },
      variables: {
        label: 'Variables and restrictions',
        text: 'Construction value, property documentation, project approval by administrator, credit release in stages, execution timeline.'
      },
      howFgt: {
        label: 'How FGT structures',
        text: 'Technical project validation, documentary feasibility analysis, credit modeling by stages, contemplation structuring, release management.'
      }
    },
    {
      id: 'planejamento-patrimonial',
      title: 'Wealth Planning',
      forWho: {
        label: 'Who is it for',
        text: 'Families and individuals with consolidated wealth seeking structured diversification and asset protection via long-term consortia.'
      },
      whenMakesSense: {
        label: 'When it makes sense',
        text: 'When there is recurring cash surplus, planning horizon above 5 years, and need for disciplined wealth structuring.'
      },
      variables: {
        label: 'Variables and restrictions',
        text: 'Risk profile, time horizon, payment capacity, wealth objectives (succession, protection, diversification), group regulations.'
      },
      howFgt: {
        label: 'How FGT structures',
        text: 'Deep wealth diagnosis, objective mapping, group portfolio modeling, risk and return analysis, continuous strategic monitoring.'
      }
    },
    {
      id: 'estruturacao-empresarial',
      title: 'Corporate Structuring',
      forWho: {
        label: 'Who is it for',
        text: 'Companies needing to acquire operational assets (headquarters, vehicles, equipment) with credit structure without compromising working capital.'
      },
      whenMakesSense: {
        label: 'When it makes sense',
        text: 'When there is need for expansion or asset acquisition with predictable cash flow and preference for long-term structured credit.'
      },
      variables: {
        label: 'Variables and restrictions',
        text: 'Asset type, property value, company monthly payment capacity, corporate documentation, administrator PJ regulations.'
      },
      howFgt: {
        label: 'How FGT structures',
        text: 'Corporate feasibility analysis, PJ credit structuring, cash flow modeling, document management, monitoring until asset delivery.'
      }
    },
    {
      id: 'cartas-contempladas',
      title: 'Contemplated Letters',
      forWho: {
        label: 'Who is it for',
        text: 'Buyers seeking immediate credit via acquisition of already contemplated letters, with technical curation and operational risk validation.'
      },
      whenMakesSense: {
        label: 'When it makes sense',
        text: 'When there is urgency in asset acquisition, capital availability for down payment (premium + paid installments), and need for immediate credit.'
      },
      variables: {
        label: 'Variables and restrictions',
        text: 'Letter value, market premium, paid installments, outstanding balance, administration fee, reserve fund, remaining term, administrator regulations.'
      },
      howFgt: {
        label: 'How FGT structures',
        text: 'Technical curation of available letters, complete documentary validation, operational risk analysis, premium negotiation, transfer and utilization monitoring.'
      }
    }
  ],
  cta: {
    title: 'Structure your wealth decision',
    subtitle: 'Schedule a strategic assessment without commitment.',
    button: 'Schedule Strategic Assessment'
  }
};